import axiosInstance from "../utils/axios"
// import { handleApiError } from "../utils/errorHandler"

export const disturbanceInformationService = {
    fetchAll: async (params = {}) => {
      const response = await axiosInstance.get('/disturbance-information/paginate', {
        params,
      })
      return response.data
    },
    getById: async (id) => {
      const response = await axiosInstance.get('/disturbance-information/' + id)
      return response.data
    },
    store: async (data) => {
      const response = await axiosInstance.postForm('/disturbance-information', data)
      return response.data
    },
    update: async (data) => {
      const response = await axiosInstance.putForm(`/disturbance-information/${data.id}`, data)
      return response.data
    },
    delete: async (id) => {
      const response = await axiosInstance.delete(`/disturbance-information/${id}`)
      return response.data
    },
}